<template>
  <section :class="showHead?'app-head-main':'app-main'">
      <router-view :key="key" />
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    },
    showHead() {
      return this.$route.meta.showHead === false ? false : true
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.app-head-main{
  min-height: calc(100vh - 124px);
}
.app-main{
  min-height: calc(100vh - 48px);
}
</style>
